import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  // Estado del Sidebar (true = abierto/expandido, false = cerrado/icono)
  private _sidebarOpen = new BehaviorSubject<boolean>(true);
  sidebarOpen$ = this._sidebarOpen.asObservable();

  // Detectar si estamos en móvil
  private _isMobile = new BehaviorSubject<boolean>(false);
  isMobile$ = this._isMobile.asObservable();

  constructor() {
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  toggleSidebar() {
    this._sidebarOpen.next(!this._sidebarOpen.value);
  }

  setSidebarState(state: boolean) {
    this._sidebarOpen.next(state);
  }

  checkScreenSize() {
    const isMobile = window.innerWidth < 992;
    this._isMobile.next(isMobile);

    if (isMobile) {
      this._sidebarOpen.next(false);
    } else {
      // Si volvemos a escritorio, lo abrimos (opcional)
      this._sidebarOpen.next(true);
    }
  }
}
